import { render, staticRenderFns } from "./scatter.vue?vue&type=template&id=084ee2e6&scoped=true&"
import script from "./scatter.vue?vue&type=script&lang=js&"
export * from "./scatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ee2e6",
  null
  
)

export default component.exports